<template>
  <div style="overflow-y: hidden">
    <div class="top">
      <div class="search_icon">
        <span style="margin-left: 10px">
          <img src="../../../../assets/u3220.png" class="icon_img" />
          筛选查询
        </span>
      </div>
      <div class="query_div">
        <a-row>
          <a-col :span="5">
            <label>出版年份：</label>
            <a-input
              placeholder="请输入"
              v-model="queryYear"
              class="query_input"
            />
          </a-col>
          <a-col :span="5">
            <label style="margin-left: 15px">出版期次：</label>
            <a-input
              placeholder="请输入"
              v-model="queryCount"
              class="query_input"
            />
          </a-col>
          <a-button type="primary" class="query_btn" @click="query">
            查询
          </a-button>
        </a-row>
      </div>
    </div>
    <div class="middle">
      <div style="float: left; margin-left: 10px">
        <img src="..\../../../assets/u3227.png" class="icon_img" />
        <span>&nbsp;数据列表</span>
      </div>

      <div class="sortType" style="float: right">
        排序方式：
        <a-select
          size="small"
          defaultValue="1"
          style="width: 120px"
          @change="sortChange"
          v-model="sort"
        >
          <a-select-option value="1">编号降序</a-select-option>
          <a-select-option value="2">编号升序</a-select-option>
          <a-select-option value="3">时间降序</a-select-option>
          <a-select-option value="4">时间升序</a-select-option>
        </a-select>
      </div>
    </div>
    <div class="bottom" id="bottom">
      <div class="table_box">
        <a-table
          :pagination="false"
          :rowSelection="rowSelection"
          :columns="columns"
          :dataSource="data"
          :rowKey="(record) => record.publishCode"
          size="small"
          :scroll="{ y: data.length < 8 ? false : table_height }"
          bordered
        >
          <span slot="publishCode" slot-scope="text, record">
            <label>{{ record.publishCode }}</label>
          </span>
          <span slot="operator" slot-scope="text, record">
            <a href="javascript:void(0);" @click="() => down(record)">
              下载清样
            </a>
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => audit(record)">
              审核
            </a>
          </span>
          <span slot="count" slot-scope="text, record">
            <label>总第{{ record.count }}期</label>
          </span>
        </a-table>
      </div>
      <div id="components-pagination-demo-mini">
        <a-pagination
          :total="total"
          :showTotal="(total) => `共 ${total} 条`"
          showSizeChanger
          showQuickJumper
          :pageSizeOptions="pageSizeOptions"
          :defaultPageSize="limit"
          @showSizeChange="onShowSizeChange"
          @change="pageChange"
        />
      </div>
    </div>
    <a-modal
      title="审核"
      v-model="visible"
      width="600px"
      @ok="enSure"
      :destroyOnClose="true"
      centered
      :maskClosable="false"
    >
      <template>
        <div class="audit-modal">
          <a-row>
            <a-col :span="6" class="title">排刊编号：</a-col>
            <a-col :span="12">
              <a-input
                placeholder="请输入"
                class="input"
                v-model="publishInfo.publishCode"
                v-bind:read-only="true"
              />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title">年份：</a-col>
            <a-col :span="12">
              <a-input
                placeholder="请输入"
                class="input"
                v-model="publishInfo.year"
                v-bind:read-only="true"
              />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title">期次：</a-col>
            <a-col :span="12">
              <a-input
                placeholder="请输入"
                class="input"
                v-model="publishInfo.auditCount"
                v-bind:read-only="true"
              />
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="6" class="title">操作人：</a-col>
            <a-col :span="12">
              <a-input
                placeholder="请输入"
                class="input"
                v-model="publishInfo.creater"
                v-bind:read-only="true"
              />
            </a-col>
          </a-row>
          <!-- <a-row>
            <a-col :span="6" class="title">提交时间：</a-col>
            <a-col :span="12">
              <a-date-picker :value="date" @change="dateChange" />
            </a-col>
          </a-row> -->
          <a-row>
            <a-col :span="6" class="title">
              <span style="color: red">*</span>审核结果：
            </a-col>
            <a-col :span="12">
              <a-select v-model="status" @change="isAgree">
                <a-select-option value="0">请选择</a-select-option>
                <a-select-option value="1">同意</a-select-option>
                <a-select-option value="2">拒绝</a-select-option>
              </a-select>
            </a-col>
          </a-row>
          <a-row v-if="agree">
            <a-col :span="6" class="title">
              <span style="color: red">*</span>拒绝原因：
            </a-col>
            <a-col :span="14">
              <a-textarea v-model="note" style="height: 100px"></a-textarea>
            </a-col>
          </a-row>
        </div>
      </template>
    </a-modal>
  </div>
</template>
<script>
const columns = [
  {
    title: "排刊编号",
    dataIndex: "publishCode",
    scopedSlots: { customRender: "publishCode" },
  },
  {
    title: "年份",
    dataIndex: "year",
  },
  {
    title: "期次",
    dataIndex: "count",
    scopedSlots: { customRender: "count" },
  },
  {
    title: "版本",
    width: 130,
    dataIndex: "sectionInfo",
  },
  {
    title: "操作人",
    dataIndex: "creater",
  },
  {
    title: "时间",
    dataIndex: "submitTime",
  },
  {
    title: "操作",
    key: "operator",
    scopedSlots: { customRender: "operator" },
  },
];
const data = [];
import qs from "qs";
export default {
  data() {
    return {
      serviceAddress: this.$config.serviceAddress,
      queryCount: "",
      queryYear: "",
      data,
      agree: false,
      columns,
      selectedRowKeys: [],
      sort: "1",
      visible: false,
      publishInfo: {},
      status: "0",
      note: "",
      sortField: "publish_code",
      sortType: "desc",
      operateCode: "0",
      page: 1,
      limit: 20,
      total: 0,
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      table_height: 0,
    };
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        columnWidth: 35,
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,
        onSelection: this.onSelection,
      };
    },
  },
  created() {
    this.query();
  },
  mounted() {
    //设置bottom高度
    var height = document.body.clientHeight;
    var bottom_height = height - 230;
    var bottom = document.getElementById("bottom");
    bottom.style.height = bottom_height + "px";
    this.table_height = bottom_height - 100;
  },
  methods: {
    query() {
      let roleCode = sessionStorage.getItem("roleCode");
      var statusList = roleCode == "4" ? [2] : [3];
      this.axios
        .get("/publishInfo/queryPublishInfo", {
          params: {
            year: this.queryYear,
            count: this.queryCount,
            statusList: statusList.join(","),
            sortField: this.sortField,
            sortType: this.sortType,
            page: this.page,
            limit: this.limit,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.total = res.data.count;
            this.data = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询稿件列表失败！");
          }
        });
    },
    isAgree() {
      if (this.status == 2) {
        this.agree = true;
      } else {
        this.agree = false;
      }
    },
    audit(record) {
      this.visible = true;
      this.publishInfo = record;
      this.publishInfo.auditCount = "总第" + record.count + "期";
    },
    enSure() {
      if (this.status == "0") {
        this.utils.messageInfo(this, "error", "请选择审核结果！");
        return;
      }
      if (this.status == "2") {
        if (this.note == "") {
          this.utils.messageInfo(this, "error", "请填写拒绝原因！");
          return;
        }
      }
      this.axios
        .post("/publishLog/savePublishLog", {
          publishCode: this.publishInfo.publishCode,
          status: this.status,
          note: this.note,
          auditer: sessionStorage.getItem("userCode"),
          roleCode: sessionStorage.getItem("roleCode"),
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "审核成功");
            this.query();
            this.visible = false;
          } else {
            this.utils.messageInfo(this, "error", "添加失败！");
          }
        });
    },
    down(record) {
      window.open(
        this.serviceAddress +
          "/publishInfo/downLoad?publishCode=" +
          record.publishCode
      );
    },
    onShowSizeChange(current, pageSize) {
      this.page = current;
      this.limit = pageSize;
      this.query();
    },
    pageChange(pageNumber) {
      this.page = pageNumber;
      this.query();
    },
    sortChange() {
      if (this.sort == 1) {
        this.sortField = "publish_code";
        this.sortType = "desc";
      } else if (this.sort == 2) {
        this.sortField = "publish_code";
        this.sortType = "";
      } else if (this.sort == 3) {
        this.sortField = "create_time";
        this.sortType = "desc";
      } else if (this.sort == 4) {
        this.sortField = "create_time";
        this.sortType = "";
      }
      this.query();
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
  },
};
</script>
<style>
@import "../../../../assets/css/PageCss.css";
</style>
<style scoped>
.audit-modal .title {
  text-align: right;
  line-height: 32px;
}
.audit-modal .note {
  font-size: 12px;
  color: red;
}
.audit-modal .ant-row {
  margin-bottom: 10px;
}
</style>
